module.exports = __webpack_public_path__ + "media/icons/box-b03073fc.svg";